"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
exports.ConversionStepCanvasInner = ({ children, isDragging, innerRef, dragHandleProps, draggableProps, isEditing, setState, }) => {
    react_1.useEffect(() => {
        if (isDragging) {
            setState({
                isEditing: false,
            });
        }
    }, [isDragging]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysDiv, Object.assign({ margin: true, shadow: isDragging ? 'lg' : true, border: true, padding: true, osysName: "ConversionStepCanvas", flexCol: true, rounded: true, innerRef: innerRef, bg: "white", "data-is-open": isEditing }, dragHandleProps, draggableProps), children)));
};
//# sourceMappingURL=Inner.js.map